const messages = {
    accountBox: {
        title: "Painel",
        description: "Acompanhe rapidamente as suas promoções e pontos.",
        button: "ABRIR PAINEL",
    },
};

export default {
    messages,
};
